<template>
  <div class='h-dialogContainer h-alarm-filter'>
    <div class="row h-row-inputBox">
        <div class='h-col-inputBox'>
          <div class='h-borderBox h-filterTopoTree height-464'>
            <div class="h-topo-treebox">
              <div class="h-borderBox-top" >
                <ejs-textbox ref='baseSearch' :title='searchTreeString' :placeholder="SearchHoder" v-model="searchTreeString" @keydown.native.enter='change'></ejs-textbox>
              </div>
              <div class="h-topo-tree">
                <ejs-treeview id='baseTree' ref='baseTree' :enablePersistence='true' :fields='fields' :nodeClicked='nodeClicked' :showCheckBox="false" :nodeChecked='checkedNodesFunc'></ejs-treeview>
              </div>
            </div>
          </div>
        </div>
    </div>
    <div class='row'>
      <div class='h-col-inputBox nopadding'>
          <div class="col-sm-2 row nopadding">
              <span class="icon hero-icon hero-icon-detailed" style="line-height: 21px;padding-left: 0;padding-right: 20px;">
              </span>
          </div>
          <div class='col-sm-11 row nopadding'>
              <div>{{$t('System.standardDes')}}</div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>

  let treeDatas = [{ children: [] }];
  let responseData = [];
  let resTemp = [];
  export default {
    name: 'selectStandardBsDialog',
    components: {},
    props: {
      message: [String, Number],
      searchBox: {
        type: Object,
        default() {
          return {
            show: true
          };
        }
      },
      checkBox: {
        type: Object,
        default() {
          return {
            show: false
          };
        }
      },
      hasBorder: { type: Boolean, default: true },
      graphType: '0',
    },
    data() {
      return {
        SearchHoder: this.$t('Topo.nodeName'),
        fields: {
          dataSource: treeDatas,
          id: 'id',
          text: 'name',
          child: 'children',
          iconCss:'icon',
          isChecked: 'isChecked',
          selected: 'selected',
          tooltip: 'name',
        },
        searchBox_: this.searchBox,
        checkBox_: this.checkBox,
        neIdListCache: {},
        nodeClicked: (args) => {
          const node = responseData[responseData.findIndex(v => v.id === args.node.dataset.uid)];
          console.log("node:",node)
        },
        searchTreeString: ''
      };
    },
    methods: {
      getTopoTreeData() {
        let url = '/lte/ems/topo/physicalView';
        const This = this;
        This.$axios.get(url).then(response => {
          if(response.data === undefined){
            return;
          }
          if(response.status === 200){
            if (response.data.errorCode === 'SUCCESS') {
              resTemp = response.data.resultVal;
              console.log("resTemp",resTemp);
              responseData = This.getTreeDataStyle();
              treeDatas = This.transfer2TreeData(responseData);
              
              This.fields = {
                dataSource: treeDatas,
                id: 'id',
                text: 'name',
                child: 'children',
                iconCss:'icon',
                isChecked: 'isChecked',
                // selected: 'selected',
                tooltip: 'name',
                expanded: 'name',
              };
            }
          }
        });
      },
      getTreeDataStyle(){
        responseData = [];
        for (let i = 0; i < resTemp.length; i++) {
          if( Number(resTemp[i].typeCode) == 30002)
            resTemp[i].onlineStatus = 1;
          // if( resTemp[i].parentId == null)
          //   resTemp[i].onlineStatus = 1;
          if(resTemp[i].onlineStatus ===1){
            const iconStyle = resTemp[i].onlineStatus ===1?
            'icon hero-icon'+' '+`${resTemp[i].icon}`+' '+'h-pm-iconOnline':
            'icon hero-icon'+' '+`${resTemp[i].icon}`+' '+'h-pm-iconOffline';
            responseData.push({
              ...resTemp[i],
              icon:iconStyle,
              id:`${resTemp[i].id}`,
              parentId:`${resTemp[i].parentId}`
            })

            if( resTemp[i].typeCode == '0'){
              responseData[i].icon = resTemp[i].onlineStatus === 1?
              'icon hero-icon hero-icon-topo-subnet h-pm-iconOnline'
              : 'icon hero-icon hero-icon-topo-subnet  h-pm-iconOffline';
            }
          }
        }
        return responseData;
      },
      change() {
        const This = this;
        if (this.searchTreeString !== '') {
          const selectData = responseData
          .filter(item => item.name.indexOf(this.searchTreeString) > -1)
          .map(item => {
            const { id, name,icon } = item;
            return {
              id,
              name,
              icon,
              isChecked: !!this.neIdListCache[id],
              children: {}
              };
            });
          if (selectData.length !== 0) {
            This.fields = {
              dataSource: selectData,
            };
          } else {
            This.fields = {
              dataSource: null,
            };
          }
        } else {
          This.fields = {
            dataSource: this.transfer2TreeData(responseData),
          };
        }
      },
      transfer2TreeData(treeData, parentId = 'null') {
        const aaaa = treeData.filter(item => parentId.indexOf(item.parentId) > -1);
        return  aaaa.map(item => {
            const { id, name, icon, selected } = item;
            return {
              isChecked: this.neIdListCache[id],
              id,
              name,
              icon,
              selected,
              children: this.transfer2TreeData(treeData, new Array(`${item.id}`))
            };
          });
      },
      checkedNodesFunc(args) {
        if (args.isInteracted) {
          if (args.action === 'check') {
            this.neIdListCache[args.data[0].id] = true;
          } else if (args.action === 'uncheck') {
            this.neIdListCache[args.data[0].id] = false;
          }
        }
      },
      uncheckAll() {
        const serachObj = this.$refs.baseSearch;
        if (serachObj) {
          serachObj.value = '';
        }
        const treeObj = this.$refs.baseTree.ej2Instances;
        treeObj.uncheckAll();
        this.neIdListCache = {};
        this.change('');
      },
      getNodeList() {
        const treeObj = this.$refs.baseTree.ej2Instances;
        const checkIdList = treeObj.selectedNodes;
        const nodeList = [];
        for (let i = 0; i < checkIdList.length; i++) {
          const node = responseData[responseData.findIndex(v => v.id === checkIdList[i])];
          nodeList.push(node);
        }
        return nodeList;
      },
    },
    mounted() {
      this.getTopoTreeData();
    }
  }
</script>